import { FunctionComponent, ReactNode } from 'react';
import { cn } from '@utils';

export interface PhaseBannerProps {
  phase: string;
  content?: string | ReactNode;
  children?: ReactNode;
  className?: string;
}

/**
 * Banner to display the phase of a website, e.g. BETA, ALPHA.
 *
 * @category Banner
 * @props phase: string
 */
export const PhaseBanner: FunctionComponent<PhaseBannerProps> = ({
  phase,
  content,
  children,
  className,
}) => {
  return (
    <div
      className={cn(
        'border-accent-highlight flex items-center border-t-[0.25rem] border-solid bg-[#071747] py-2 max-md:py-1',
        className,
      )}
    >
      <div className="mx-[calc(12.5%+2rem)] flex flex-1 items-center gap-x-2 max-md:mx-4">
        <strong className="bg-accent-highlight text-brand-primary font-source-sans-pro rounded-[0.25rem] px-[0.3rem] text-[0.75rem] font-bold leading-[1.125rem] opacity-90">
          {phase}
        </strong>
        <span className="font-source-sans-pro text-body leading-[1.625rem] tracking-[-0.01875rem] text-[#e2e6f2] opacity-90">
          {content ?? children}
        </span>
      </div>
    </div>
  );
};
